import { useCallback, useMemo } from 'react';
import { useSelectedAccount } from '@ibk/shared-auth';
import { PermissionsDomains, PermissionsResources } from '@ibk/shared-types';
import { isValidCnpj } from '@ibk/shared-utils';
import { useRequiresAuthorization } from '../useRequiresAuthorization';
export const useOperatorMenuVisibility = () => {
    const { selectedAccount } = useSelectedAccount();
    const showCreateOperator = useRequiresAuthorization(PermissionsDomains.AUTHORIZATION, PermissionsResources.AUTHORIZATION_CREATE_OPERATOR);
    const canSeeOperator = useCallback(() => {
        if (!showCreateOperator) {
            return false;
        }
        return isValidCnpj(selectedAccount?.documentNumber);
    }, [showCreateOperator, selectedAccount?.documentNumber]);
    return useMemo(() => canSeeOperator(), [canSeeOperator]);
};
